import { useI18nContext } from '@lemonade-hq/nuiza';
import { Flex, IconButton, Rating, Text, useModal, useViewportSize } from '@lemonade-hq/uniclient-theme';
import { useCallback, useState } from 'react';
import type { FC } from 'react';
import * as styles from './WizardSurvey.css';

export const WizardSurvey: FC<{
  readonly scoreAttribute: string;
  readonly commentAttribute: string;
  readonly openSurveyDialog: (initialRating: number, scoreAttribute: string, commentAttribute: string) => void;
  readonly stepAnswers: Record<string, unknown>;
}> = ({ scoreAttribute, commentAttribute, openSurveyDialog, stepAnswers }) => {
  const { isMobileViewport } = useViewportSize();
  const [closed, setClosed] = useState<boolean>(false);
  const { isOpen } = useModal();
  const { s } = useI18nContext();

  const handleInitialSetRating = useCallback(
    (newRating: number) => {
      openSurveyDialog(newRating, scoreAttribute, commentAttribute);
    },
    [openSurveyDialog, scoreAttribute, commentAttribute],
  );

  return stepAnswers[scoreAttribute] != null || isOpen || closed ? null : (
    <Flex
      alignItems="center"
      backgroundColor="$backgroundPrimary"
      className={styles.wizardSurveyContent({ isMobileViewport })}
      flexDirection="column"
    >
      <IconButton
        background="transparent"
        className={styles.closeButton}
        icon="close"
        onClick={() => setClosed(true)}
        size="lg"
      />
      <Text textAlign="center" type="h4">
        {s('chat.survey.title')}
      </Text>
      <Rating className={styles.rating} onChange={handleInitialSetRating} value={0} />
    </Flex>
  );
};
